function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css, css as _css } from '@emotion/react';
import { Menu, MenuButton } from '@arc/frontend/ui-common';
import { su } from '@arc/frontend/ui-theme';
import { ColorPicker } from '../Color';
const swatchStyle = /*#__PURE__*/css(su.roundedSm, "display:inline-block;width:2.5rem;height:2.5rem;overflow:hidden;border:#ddd 1px solid;" + (process.env.NODE_ENV === "production" ? "" : ";label:swatchStyle;"));
var _ref = process.env.NODE_ENV === "production" ? {
  name: "m1a2da",
  styles: "padding:0.5rem"
} : {
  name: "145tsaa-SelectorColor",
  styles: "padding:0.5rem;label:SelectorColor;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function SelectorColor({
  color,
  onChange,
  disableAlpha = true,
  trigger,
  ...buttonProps
}) {
  return <Menu trigger={trigger ?? <MenuButton css={swatchStyle} aria-label={buttonProps['aria-label'] ?? 'Select color'} {...buttonProps}>
						<div css={/*#__PURE__*/_css({
      width: '100%',
      height: '100%',
      background: color
    }, process.env.NODE_ENV === "production" ? "" : ";label:SelectorColor;")} />
					</MenuButton>}>
			<div css={_ref}>
				<ColorPicker color={color} onChange={onChange} disableAlpha={disableAlpha} />
			</div>
		</Menu>;
}